module.exports = __webpack_public_path__ + "static/media/AD.a8e1eb60.svg";